/* global ViewController, WebView */
var docShareController = new ViewController({
    directory : "views/public",
    name: "docShare",
    container: "main",
    route: "doc-share"
}) ;

docShareController.prepareDataOnEnter = function(token, callback){
    this.api.public.getShareSettings(function(err, settings){
        if(err) {return callback(err) ;}

        this.api.public.getSharedDocument(token, function(err, doc){
            if(err){
                if(err === "EXPIRED"){
                    return callback(null, { expired: true }) ;
                }
                if(err === "NOT_FOUND"){
                    return callback(null, { notfound: true }) ;
                }
                return callback(err) ;
            }
            if(settings.attach){
                doc.hasCustomBg = true ;
            }
            callback(null, doc) ;
        }.bind(this)) ;
    }.bind(this)) ;
};

docShareController.onDownload = function(){
    if(!this.data.share_password){
        this.view.longTask(function(done){
            this.api.public.downloadSharedDocument(this.data.share_uuid, done) ;
        }.bind(this)) ;
    }else{
        var viewChange = new WebView("views/public", "docSharePasswordPopup") ;
        viewChange.openInPopup({
            title: ''
        })  ;
        viewChange.on("validate",function(){
            var passData = viewChange.getData() ;
            viewChange.close() ;
            this.view.longTask(function(done){
                this.api.public.checkPassSharedDocument(this.data.share_uuid, passData.share_password, function(err){
                    if(err){
                        if(err === "WRONG_PASSWORD"){
                            return done(WebView.tr("docShare.wrongPassword")) ;
                        }
                        return done(err) ;
                    }
                    this.api.public.downloadSharedDocument(this.data.share_uuid, passData.share_password, function(err){
                        if(err){
                            if(err === "WRONG_PASSWORD"){
                                return done(WebView.tr("docShare.wrongPassword")) ;
                            }
                            return done(err) ;
                        }
                        done() ;
                    }.bind(this)) ;
                }.bind(this)) ;
            }.bind(this)) ;
        }.bind(this)) ;
    }
} ;


module.exports = docShareController ;